// extracted by mini-css-extract-plugin
module.exports = {"spinner":"PageSpinner_spinner__2qFsj"};